/* LIMITLESS — tema Shopify. Menu, tickers e galeria.
   Carrinho, variantes e checkout são do Shopify; a section do produto
   traz seu próprio script de variantes + frase. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Tickers: duplica o conteúdo pro loop de -50% nunca abrir buraco */
  $$('.ticker__track').forEach(function (t) {
    if (t.dataset.lmFilled) return;
    t.dataset.lmFilled = '1';
    var html = t.innerHTML;
    var guard = 0;
    while (t.scrollWidth < window.innerWidth * 2 && guard++ < 12) { t.innerHTML += html; }
    t.innerHTML += t.innerHTML;
  });

  /* Menu próprio (só se o tema não usar o header do Dawn) */
  var burger = $('.burger'), drawer = $('#drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      drawer.classList.toggle('is-open', !open);
    });
  }
  var hd = $('.hd');
  if (hd) {
    var onScroll = function () { hd.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
